import { Trans } from '@lingui/react/macro';
import { CreditCardDown } from '@untitledui/icons/CreditCardDown';
import { CurrencyDollarCircle } from '@untitledui/icons/CurrencyDollarCircle';

export function FaqSection() {
  return (
    <section className="bg-primary py-8">
      <div className="mx-auto max-w-[var(--max-width-container)] px-4 py-4 md:px-8">
        {/* Header */}
        <div className="mb-8 md:mb-12">
          <h2 className="mb-2 font-heading text-display-xs font-semibold text-primary">
            <Trans>Frequently asked questions</Trans>
          </h2>
          <p className="text-md text-secondary">
            <Trans>
              Can't find the answer you're looking for? Please go to our{' '}
              <a
                href="https://help.respondent.io"
                className="underline hover:text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help Center
              </a>
              .
            </Trans>
          </p>
        </div>

        {/* FAQ Grid - 2 columns on desktop, 1 on mobile */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-8 md:gap-y-16">
          <FaqItem
            icon={CurrencyDollarCircle}
            question={
              <Trans>
                Why is my participation incentive lower than expected?
              </Trans>
            }
            answer={
              <Trans>
                Fulfillment Fee: Participants are paid the advertised incentive
                amount by the Researcher, less a 5% ($1.00 USD minimum)
                processing fee.
              </Trans>
            }
          />
          <FaqItem
            icon={CreditCardDown}
            question={
              <Trans>What is the status of my incentive payment?</Trans>
            }
            answer={
              <Trans>
                Payments made from Researchers should always be completed in our
                platform and paid via <strong>Tremendous</strong> eGift
              </Trans>
            }
          />
        </div>
      </div>
    </section>
  );
}

interface FaqItemProps {
  icon: React.ComponentType<{ className?: string }>;
  question: React.ReactNode;
  answer: React.ReactNode;
}

function FaqItem({ icon: Icon, question, answer }: FaqItemProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* Icon in purple circle */}
      <div className="flex size-12 items-center justify-center rounded-full bg-brand-primary">
        <Icon className="size-6 text-brand-600" />
      </div>
      {/* Text content */}
      <div className="flex flex-col gap-1">
        <h3 className="text-lg font-semibold text-primary">{question}</h3>
        <p className="text-md text-tertiary">{answer}</p>
      </div>
    </div>
  );
}
